export default "__VITE_ASSET__Dc7oa2Y$__"